import { render, staticRenderFns } from "./UmkmTypeView.vue?vue&type=template&id=e5a154e8&scoped=true"
import script from "./UmkmTypeView.vue?vue&type=script&lang=js"
export * from "./UmkmTypeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a154e8",
  null
  
)

export default component.exports